import { render, staticRenderFns } from "./sys_role.vue?vue&type=template&id=422fb6e5&scoped=true"
import script from "./sys_role.vue?vue&type=script&lang=js"
export * from "./sys_role.vue?vue&type=script&lang=js"
import style0 from "./sys_role.vue?vue&type=style&index=0&id=422fb6e5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422fb6e5",
  null
  
)

export default component.exports